let serverUrl: string | undefined

export function getServerUrl() {
	if (serverUrl == null) {
		const url = new URL(location.href)
		url.hash = ''
		url.search = ''
		url.pathname = ''
		serverUrl = url.toString().replace(/\/+$/, '')
	}
	return serverUrl
}
